// Swing formed and higher/lower high/low events are stamped on the bar the
// swing was confirmed (DWLF-330), a few bars after the high or low itself.
// Their tooltip names both days, as confirmed cycle pivots do.

export const SWING_PIVOT_EVENT_IDS = new Set([
  'swing_high_formed', 'swing_low_formed', 'higher_high', 'lower_high', 'higher_low', 'lower_low',
]);


// Daily and weekly bars sit whole days apart; a gap that is not a whole
// number of days is a sub-daily swing, whose hours are the point.
const DAY_MS = 86_400_000;

/**
 * Tooltip lines for a swing pivot event: the pivot and the confirming bar.
 * `formatDate` renders a timestamp's day; `formatDateTime`, when given, is
 * used for a sub-daily swing (pivot and confirmation not a whole number of
 * days apart, across midnight or not), so the hours between them show.
 */
export const swingPivotLines = (event, formatDate, formatDateTime = null) => {
  if (!SWING_PIVOT_EVENT_IDS.has(event?.id)) {return [];}
  const pivotTime = event?.payload?.pivotTime;
  const confirmedTime = event?.t;
  const gap = Number.isFinite(pivotTime) && Number.isFinite(confirmedTime) ? confirmedTime - pivotTime : null;
  const subDaily = gap !== null && gap > 0 && gap % DAY_MS !== 0;
  const fmt = subDaily && formatDateTime ? formatDateTime : formatDate;
  const pivot = fmt(pivotTime);
  const confirmed = fmt(confirmedTime);
  const lines = [];
  if (pivot) {lines.push(`Pivot: ${pivot}`);}
  if (confirmed && confirmed !== pivot) {lines.push(`Confirmed: ${confirmed}`);}
  return lines;
};
